import { InjectionKey } from 'vue';
import QueryString from 'qs';
import { Statistic } from '@/shared/service/StatisticService';

export const queryKey = Symbol() as InjectionKey<QueryString.ParsedQs>;

export const statisticKey = Symbol() as InjectionKey<InstanceType<typeof Statistic>>;
